module.exports = __webpack_public_path__ + "img/icon_news_bg.05b89026.png";